import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=15af6764&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=ts"
export * from "./Emoji.vue?vue&type=script&lang=ts"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=15af6764&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af6764",
  null
  
)

export default component.exports